import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Stack,
    Typography,
    styled,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {useI18n} from 'store/Store'

import useYoutubeUploadStatus from 'logic/Dances/useYoutubeUploadStatus'
import StatusesTable from './StatusesTable'

const YoutubeStatusSection = ({videoType}) => {
    const {i18n} = useI18n()

    const {data, statusKeys, iconsMap, hideExpand} =
        useYoutubeUploadStatus(videoType)

    return (
        <StyledAccordion
            elevation={0}
            disabled={hideExpand}
            hideExpand={hideExpand}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{cursor: 'default'}}>
                <Typography component="span" sx={{width: '15%', flexShrink: 0}}>
                    {i18n.t(`dances.${videoType}`)}:
                </Typography>
                <Stack direction="row" gap={3} alignItems="center">
                    {statusKeys.map((statusKey) => {
                        return (
                            <Typography
                                key={statusKey}
                                component="span"
                                sx={{color: 'text.secondary'}}>
                                <Stack direction="row" gap={0.5}>
                                    {iconsMap[statusKey]}
                                    <Typography>
                                        {i18n.t(
                                            `dances.youtubeStatuses.${statusKey}`
                                        )}
                                    </Typography>
                                    -
                                    <Typography fontWeight={300}>
                                        {data?.counts?.[statusKey]}
                                    </Typography>
                                </Stack>
                            </Typography>
                        )
                    })}
                </Stack>
            </AccordionSummary>
            <AccordionDetails>
                <StatusesTable videoType={videoType} />
            </AccordionDetails>
        </StyledAccordion>
    )
}

export default YoutubeStatusSection

const StyledAccordion = styled(Accordion, {
    shouldForwardProp: (prop) => prop !== 'hideExpand',
})(({theme, hideExpand}) => ({
    '&.Mui-disabled': {
        backgroundColor: 'transparent',
    },

    '&.Mui-disabled .MuiAccordionSummary-root.Mui-disabled': {
        opacity: '1',
    },

    '& .MuiAccordionSummary-expandIconWrapper': {
        visibility: hideExpand ? 'hidden' : undefined,
    },
}))
